module.exports = __webpack_public_path__ + "static/media/6masala-mb-en.484f632d.jpg";